export default "__VITE_ASSET__COLKIVMX__"